import http from '../util/http';

import { setLocalData } from '../util/util';
import { endPoints } from '../config';
import { history } from '../history/history';
import { ANY_ERROR } from './user_action_types';

export const login= data=> async dispatch=> {
  const response= await http.post(endPoints.salesUserLogin, data);
  if(response && response.data.statusCode== 200) {
    setLocalData('salesUserInfo', response.data.data);
    setLocalData("userInfo", response.data.data);
    if(response.data.data.kycstatus && response.data.data.kycstatus.status === 'Verified'){
      history.push('/tp/incentivedetails');      
    }else{
      history.push('/tp/EditKycDetails');
    }
  }
  else {
    dispatch({
      type: ANY_ERROR,
      payload: response? response.data.message: "NO RESPONSE"
    });
  }
}



// WEBPACK FOOTER //
// ./web/action/salesUser_action.jsx